var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#2F65CC",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.36 16.77L30.07 14C29.65 10.98 28.28 9.75 25.35 9.75H22.99H21.51H18.47H16.99H14.59C11.65 9.75 10.29 10.98 9.86002 14.03L9.59002 16.78C9.49002 17.85 9.78002 18.89 10.41 19.7C11.17 20.69 12.34 21.25 13.64 21.25C14.9 21.25 16.11 20.62 16.87 19.61C17.55 20.62 18.71 21.25 20 21.25C21.29 21.25 22.42 20.65 23.11 19.65C23.88 20.64 25.07 21.25 26.31 21.25C27.64 21.25 28.84 20.66 29.59 19.62C30.19 18.82 30.46 17.81 30.36 16.77Z",
    fill: "#2F65CC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.35 25.1602C18.08 25.2902 17.12 26.3702 17.12 27.6502V30.3902C17.12 30.6602 17.34 30.8802 17.61 30.8802H22.38C22.65 30.8802 22.87 30.6602 22.87 30.3902V28.0002C22.88 25.9102 21.65 24.9202 19.35 25.1602Z",
    fill: "#2F65CC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.37 22.9001V25.8801C29.37 28.6401 27.13 30.8801 24.37 30.8801C24.1 30.8801 23.88 30.6601 23.88 30.3901V28.0001C23.88 26.7201 23.49 25.7201 22.73 25.0401C22.06 24.4301 21.15 24.1301 20.02 24.1301C19.77 24.1301 19.52 24.1401 19.25 24.1701C17.47 24.3501 16.12 25.8501 16.12 27.6501V30.3901C16.12 30.6601 15.9 30.8801 15.63 30.8801C12.87 30.8801 10.63 28.6401 10.63 25.8801V22.9201C10.63 22.2201 11.32 21.7501 11.97 21.9801C12.24 22.0701 12.51 22.1401 12.79 22.1801C12.91 22.2001 13.04 22.2201 13.16 22.2201C13.32 22.2401 13.48 22.2501 13.64 22.2501C14.8 22.2501 15.94 21.8201 16.84 21.0801C17.7 21.8201 18.82 22.2501 20 22.2501C21.19 22.2501 22.29 21.8401 23.15 21.1001C24.05 21.8301 25.17 22.2501 26.31 22.2501C26.49 22.2501 26.67 22.2401 26.84 22.2201C26.96 22.2101 27.07 22.2001 27.18 22.1801C27.49 22.1401 27.77 22.0501 28.05 21.9601C28.7 21.7401 29.37 22.2201 29.37 22.9001Z",
    fill: "#2F65CC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg01);
export default __webpack_public_path__ + "static/media/01.19cf59434af1b1abdb4253e33a16c9c0.svg";
export { ForwardRef as ReactComponent };